import { ReactNode } from "react";

import { Container as BarContainer, Box as BarBox, StickySpacer } from "../../../../components/SaveBar/styles";
import { Crumb, ScreenHeader } from "../../../../components/SubHeader";
import CreationProgress from "../../../Editor/components/CreationProgress";
import { Page } from "./styles";

type Props = {
  title: string;
  back: Crumb;
  /** The fixed bar at the bottom: the way back (or out) on the left, the main action on the right. */
  bar: ReactNode;
  children: ReactNode;
};

/**
 * Paying while creating or editing a Keepo: the payment screen dressed as the flow's other steps (header with
 * the way back, the steps on top, the fixed bar, and the Keepo's preview on the side, shown by the AppShell).
 * Opened from anywhere else, it keeps its own look.
 */
export const FlowLayout = ({ title, back, bar, children }: Props) => (
  <Page>
    {/* where the person is in the flow, on top; the screen's own header under it */}
    <CreationProgress step="ready" />
    <ScreenHeader title={title} back={back} />
    {/* Subscribing comes right before publishing: the last group of steps */}
    {children}
    <StickySpacer />
    <BarBox $sticky>
      <BarContainer>{bar}</BarContainer>
    </BarBox>
  </Page>
);
